import { render, staticRenderFns } from "./handItems.vue?vue&type=template&id=39843fa8"
import script from "./handItems.vue?vue&type=script&lang=js"
export * from "./handItems.vue?vue&type=script&lang=js"
import style0 from "./handItems.vue?vue&type=style&index=0&id=39843fa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports